// client/src/config/categories.js
export const PRODUCT_CATEGORIES = [
  "Dialysis Supplies",
  "Laboratory Supplies",
  "Surgical Supplies",
  "Radiological Supplies",
  "Medical Supplies",
  "Monitoring Equipment"
  // Add any other categories you need here
];